import { Link } from 'react-router-dom';
import { CheckCircle, Phone } from 'lucide-react';
import { Button } from '../components/ui/button';
import { getWhatsAppLink } from '../lib/utils';

export const RegistrationSuccessPage = () => {
  return (
    <div className="min-h-screen bg-alabaster flex items-center justify-center px-4" data-testid="registration-success-page">
      <div className="max-w-md text-center">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-10 h-10 text-green-500" />
        </div>
        <h1 className="font-heading text-3xl font-bold text-navy-900 mb-4">
          Registration Submitted!
        </h1>
        <p className="text-gray-600 mb-8">
          Thank you for registering with DrPortals. Our team will review your application and get back to you within 24-48 hours.
        </p>
        <div className="flex flex-col gap-4">
          <a href={getWhatsAppLink("Hi, I just submitted my doctor registration.")} target="_blank" rel="noopener noreferrer">
            <Button className="w-full rounded-full bg-whatsapp hover:bg-whatsapp/90 text-white py-6 gap-2">
              <Phone className="w-5 h-5" />
              Contact Us on WhatsApp
            </Button>
          </a>
          <Link to="/">
            <Button variant="outline" className="w-full rounded-full border-navy-800 text-navy-800">
              Back to Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
